<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back">
        <mat-icon color="primary">arrow_back_ios</mat-icon>
    </button>
    <h3>{{ patient | patientHeading:'Morbidity/Mortality Note' }}</h3>
    <div>
        <button mat-icon-button *ngIf="editingNote && editingNote.id" (click)="deleteNote()" matTooltip="Delete Note">
            <mat-icon color="warn">delete</mat-icon>
        </button>
        <button mat-icon-button [disabled]="form.invalid" (click)="saveNote()" matTooltip="Save Note">
            <mat-icon [color]="form.invalid ? '' : 'primary'">save</mat-icon>
        </button>
    </div>
</mat-toolbar>

<div class="note-details-container">
    <form [formGroup]="form">
        <mat-card>
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="dateDatePicker" formControlName="date" placeholder="DD/MM/YYYY"
                    [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dateDatePicker></mat-datepicker>
            </mat-form-field>


            <div class="toggle-container">
                <mat-slide-toggle formControlName="isMorbidity" color="primary"
                    (change)="toggleMorbidity($event)">Morbidity</mat-slide-toggle>
                <mat-slide-toggle formControlName="isMortality" color="primary" (change)="toggleMortality($event)"
                    class="m-l-5">Mortality</mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Reason</mat-label>
                <mat-select formControlName="title">
                    <mat-option *ngFor="let reason of mmReasons" [value]="reason">
                        {{ reason }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Notes</mat-label>
                <textarea matInput cdkTextareaAutosize="true" rows="10" formControlName="notes"></textarea>
            </mat-form-field>

            <app-file-upload [fileObjects]="loadedNoteMediaObjects" [allowMultiple]="true"
                [allowedFileTypes]="'image/*, application/pdf'" title="Note Media"
                (fileUpload)="onNoteMediaUpload($event)" (fileDelete)="onNoteMediaDelete($event)"
                (filesEdited)="onFilesEdited($event)" [cameraEnabled]="true" [enableEditing]="true">
            </app-file-upload>
        </mat-card>
    </form>

    <div class="mobile-spacer"></div>
</div>